import { getClientConfig } from "src/config/client";

enum ipType {
  ipv4 = "IPv4",
  ipv6 = "IPv6",
}

interface ipapiResponseBody {
  ip: string;
  version: ipType;
}

export const ipClient = async (): Promise<string> => {
  const ipApiRootUrl = getClientConfig()?.ipapiURL;
  if (!ipApiRootUrl) {
    throw new Error("unable to get IP address-access: root-URL not set for IPAPI");
  }

  const resp = await fetch(`${ipApiRootUrl}/json`);

  if (!resp.ok) {
    throw new Error("unable to get IP address");
  }

  const body: ipapiResponseBody = await resp.json();

  if (body.version != ipType.ipv4) {
    throw new Error(`invalid IP address--IPv4 address required but ${body?.version} address provided`);
  }

  const ip = body?.ip + "/32";

  return ip;
};
